/* CUSTOM: EU-Versandpause in der Shopify-Versandrichtlinie ausweisen. */
(function () {
  function replaceParagraph(root, before, after, note) {
    const paragraph = Array.from(root.querySelectorAll('p')).find((item) => item.textContent.trim() === before);
    if (!paragraph) return;
    paragraph.textContent = after;
    const small = document.createElement('p');
    small.className = 'shipping-pause-note';
    small.textContent = note;
    paragraph.after(small);
  }

  function strikeRate(root, label) {
    const item = Array.from(root.querySelectorAll('li')).find((candidate) => candidate.textContent.trim().startsWith(label));
    if (!item || item.querySelector('del')) return;
    const deleted = document.createElement('del');
    while (item.firstChild) deleted.appendChild(item.firstChild);
    item.appendChild(deleted);
    item.classList.add('shipping-paused-rate');
  }

  const policy = document.querySelector('.shopify-policy__body');
  if (!policy) return;

  replaceParagraph(
    policy,
    'Ich biete Versand innerhalb der Europäischen Union sowie eine kostenlose Abholung im Studio in Frankfurt am Main an.',
    'Ich biete Versand innerhalb Deutschlands sowie eine kostenlose Abholung im Studio in Frankfurt am Main an.',
    'Der Versand ins EU-Ausland ist vorübergehend ausgesetzt.'
  );
  strikeRate(policy, 'EU-Ausland:');

  replaceParagraph(
    policy,
    'I offer delivery within the European Union as well as local pick-up at my studio in Frankfurt am Main.',
    'I offer delivery within Germany as well as local pick-up at the studio in Frankfurt am Main.',
    'Shipping to other EU countries is temporarily paused.'
  );
  strikeRate(policy, 'Within the EU:');
})();
